module.exports = __webpack_public_path__ + "static/media/noa.70a9c688.png";